<template>
  <div>
    <vue-headful :title="`Create an Order - Halalize for Business`" />
    <v-container fluid>
      <v-layout>
        <v-flex xs7 md8>
          <div class="grid-content bg-purple">
            <el-card class="box-card mb-3">
              <h3 class="title font-weight-black mb-3">Create new order</h3>
              <div>
                <el-select
                  style="width:100%;"
                  v-model="order.store_id"
                  placeholder="Select Store"
                  @change="onSelectStore(order.store_id)"
                >
                  <el-option
                    v-for="item in storeList"
                    :key="item.store_id"
                    :label="item.store_info.find(x=>x.lang=='th').store_name"
                    :value="item.store_id"
                  ></el-option>
                </el-select>
              </div>
            </el-card>
            <el-card class="box-card mb-3">
              <h3 class="title font-weight-black mb-3">Select Product</h3>
              <el-table stripe :data="productList" style="width:100%">
                <el-table-column label="Name" width="380">
                  <template slot-scope="props">
                    <h4>{{props.row.name}}</h4>
                    <div>{{props.row.product_status}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="Price" align="right" width="100">
                  <template slot-scope="props">
                    <div>{{props.row.unit_price}}</div>
                    <div>{{props.row.sale_price}}</div>
                  </template>
                </el-table-column>
                <el-table-column align="right" label="Quantity">
                  <template slot-scope="props">
                    <el-input-number
                      size="small"
                      v-model="props.row.quantity"
                      @change="handleQuantityChanged(props.row)"
                      :min="0"
                      :max="1000"
                    ></el-input-number>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
            <el-card class="box-card mb-3">
              <el-collapse v-model="activeNames">
                <el-collapse-item
                  v-if="order.channel=='callcenter'"
                  title="Customer Detail"
                  name="0"
                >
                  <el-row :gutter="0">
                    <el-col :span="24">
                      <div class="py-3">
                        <el-form
                          inline
                          ref="form"
                          label-position="left"
                          :model="user"
                          size="small"
                          @submit.native.prevent
                        >
                          <el-form-item label="Mobile Number">
                            <el-input v-model="form.mobile" size="mini"></el-input>
                          </el-form-item>
                          <el-form-item>
                            <el-button type="danger" size="mini" @click="findMobile">Query</el-button>
                            <el-button
                              type="danger"
                              size="mini"
                              v-if="!user.firstname"
                              @click="recipientDialog=true"
                            >Add Recipient</el-button>
                          </el-form-item>
                        </el-form>
                        <v-layout align-center wrap row>
                          <v-flex md6 class="pa-2" v-if="user.firstname">
                            <div class="select-box selected">
                              #{{user.id}} {{user.firstname}} {{user.lastname}}
                              <br />
                              ({{user.mobile}})
                            </div>
                          </v-flex>
                          <v-flex xs6 md3 class="pa-2" v-else>
                            <template v-if="order.recipient!=null">
                              <div class="select-box selected">
                                {{order.recipient.firstname}} {{order.recipient.lastname}}
                                <br />
                                ({{order.recipient.mobile}})
                              </div>
                            </template>
                          </v-flex>
                        </v-layout>
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>

                <el-collapse-item title="Payments" name="1">
                  <v-layout align-center wrap row>
                    <v-flex
                      xs6
                      md3
                      class="pa-2"
                      v-for="(item, index) in paymentList"
                      v-bind:key="index"
                    >
                      <div
                        v-bind:class="{ 'selected': item.selected }"
                        class="select-box text-xs-center"
                        @click="onPaymentChanged(item)"
                      >{{item.name}}</div>
                    </v-flex>
                  </v-layout>
                </el-collapse-item>
                <el-collapse-item title="Remark" name="2">
                  <el-row :gutter="15">
                    <el-col :span="12">
                      <div class="py-3">
                        <el-form
                          ref="form"
                          label-position="top"
                          :model="user"
                          size="small"
                          label-width="80px"
                        >
                          <el-form-item label="Internal">
                            <el-input type="textarea" v-model="order.remark_internal" rows="4"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="py-3">
                        <el-form
                          ref="form"
                          label-position="top"
                          :model="user"
                          size="small"
                          @submit.native.prevent
                        >
                          <el-form-item label="Public">
                            <el-input type="textarea" v-model="order.remark_public" rows="4"></el-input>
                          </el-form-item>
                        </el-form>
                      </div>
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-card>
          </div>
        </v-flex>
        <v-flex xs5 md4 class="pl-3">
          <div class="sticky">
            <el-card class="box-card">
              <h3 class="title font-weight-black mb-3">Summary</h3>
              {{order.amount}}
              <div class="mt-3">
                <el-button
                  type="primary"
                  style="width:100%;"
                  @click="onCreateOrder()"
                >Place an Order</el-button>
              </div>
            </el-card>
          </div>
        </v-flex>
      </v-layout>
      <recipient-dialog
        :showDialog="recipientDialog"
        @save="onSaveRecipient"
        @close="recipientDialog=false"
      ></recipient-dialog>
    </v-container>
  </div>
</template>
<script>
const RecipientDialog = () => import("@/components/RecipientDialog");

import Service from "../../../services";
import moment from "moment";
export default {
  components: {
    RecipientDialog
  },
  data() {
    return {
      loading: false,
      recipientDialog: false,
      date: "",
      storeList: [],
      productList: [],
      basket: [],
      form: { mobile: "" },
      user: { mobile: "" },
      order: {
        channel: "callcenter",
        store_id: null,
        recipient: null,
        payment_type: "cash",
        remark_internal: "",
        remark_public: "",
        basket: null,
        amount: {
          sub_total: 0,
          delivery_fee: 0,
          extra_fee: 0,
          discount: 0,
          save: 0,
          total: 0
        }
      },
      paymentList: [
        { name: "Cash", value: "cash", selected: true },
        { name: "Bank Transfer", value: "transfer", selected: false },
        { name: "Credit Card", value: "creditcard", selected: false },
        { name: "Line Pay", value: "linepay", selected: false }
      ],
      activeNames: ["0"]
    };
  },
  created() {
    this.date = moment().format("LLLL");

    Service.CommerceStore.gets().then(res => {
      this.storeList = res.data;
    });
  },
  methods: {
    findMobile() {
      this.showLoading();
      Service.Auth.checkIndentity("mobile", this.form.mobile).then(res => {
        if (res.data.found) {
          Service.Auth.getUser(res.data.user.id).then(user => {
            this.user = user.users[0];
            this.order.recipient = this.user;
            this.hideLoading();
          });
        } else {
          this.recipientDialog = true;
          this.hideLoading();
        }
      });
    },
    onSelectStore(store_id) {
      Service.CommerceStore.getProducts(store_id).then(res => {
        this.productList = res.data.map(item => {
          return {
            ...item,
            name: item.product_info.find(x => x.lang == "th").product_name,
            unit_price: item.unit_price,
            sale_price: item.sale_price,
            product_status: item.product_status,
            quantity: 0
          };
        });
      });
    },
    handleQuantityChanged(row) {
      if (row.product_status == "published") {
        let index = this.basket.findIndex(x => x.product_id == row.product_id);
        if (index == -1) {
          //row.quantity++;
          this.basket.push(row);
        }

        this.order.basket = [
          { store_id: this.order.store_id, items: this.basket }
        ];

        Service.CommerceOrder.basket(this.order).then(res => {
          if (res.success) {
            this.order.amount = res.data.order.amount;
          }
        });
      } else {
        alert("this product not published.");
      }
    },
    onPaymentChanged(selected) {
      this.paymentList = this.paymentList.map(item => {
        if (item.value == selected.value) {
          this.order.payment_type = item.value;
          return { ...item, selected: true };
        } else {
          return { ...item, selected: false };
        }
      });
    },
    onCreateOrder() {
      this.order.recipient = {
        ...this.order.recipient,
        name: this.order.recipient.firstname
      };

      this.showLoading();
      Service.CommerceOrder.create(this.order).then(res => {
        if (res.success) {
          this.$router.push(
            "/commerce/view/order/" + res.data.order.order_reference
          );
        }
        this.hideLoading();
      });
    },
    onSaveRecipient(data) {
      this.order.recipient = data;
      this.recipientDialog = false;
    },
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
    },
    hideLoading() {
      this.loading.close();
    }
  }
};
</script>